import React, { useEffect, useState } from "react";
import "./style.scss";
import AuthFrame from "../../../components/Auth/AuthFrame";
import SigninForm from "../../../components/Auth/SigninForm";
import SignupForm from "../../../components/Auth/SignupForm";
import ForgotPasswordForm from "../../../components/Auth/ForgotPasswordForm";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import { AcctokenD, setTheme } from "../../../store/actions";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import Logo from "../../../assets/images/SignupImg/Logo.svg";

function Signin() {
  const [errormodalOpen, setErrorModalOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { referalCode, token } = useParams();
  const [activeTab, setActiveTab] = useState("signin");
  const navigate = useNavigate();
  console.log(token, "tokentokentokentoken");

  const [isAuthFrameHidden, setIsAuthFrameHidden] = useState(false); // State to hide/show AuthFrame

  useEffect(() => {
    dispatch(setTheme("light"));
  }, [dispatch]);

  useEffect(() => {
    if (token) {
      dispatch(AcctokenD(token));
    }
  }, [token]);
  // Determine active tab based on pathname
  useEffect(() => {
    if (location.pathname.includes("signup")) setActiveTab("signup");
    else if (location.pathname.includes("forgot-password"))
      setActiveTab("forgot-password");
    else setActiveTab("signin");
  }, [location.pathname]);

  // Function to handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (!location.pathname.includes(tab)) {
      navigate(`/${tab}`);
    }
    if (window.innerWidth <= 1340) {
      setIsAuthFrameHidden(true);
    }
  };
  return (
    <div
      className={`signin-container ${
        activeTab === "signin" || activeTab === "forgot-password"
          ? "overFlow_hidden"
          : "overflow_normal"
      }`}
    >
      {errormodalOpen && (
        <ErrorModal setModalOpen={setErrorModalOpen} btnText="Close" />
      )}
      <div className="signin-left-wrapper">
        <div className={`signin-right ${isAuthFrameHidden ? "hidden" : ""}`}>
          <AuthFrame />
          <div
            className={`auth_mobileTabs ${isAuthFrameHidden ? "hidden" : ""}`}
          >
            <button
              className={activeTab === "signin" ? "active" : ""}
              onClick={() => handleTabClick("signin")}
            >
              Sign In
            </button>
            <div className="auth_mobileTabs_line"></div>
            <button
              className={activeTab === "signup" ? "active" : ""}
              onClick={() => handleTabClick("signup")}
            >
              Sign Up
            </button>
          </div>
        </div>
        <div className={`signin-left ${isAuthFrameHidden ? "hidden" : ""}`}>
          <div className={`authLogo_img ${!isAuthFrameHidden ? "hidden" : ""}`}>
            <img src={Logo} alt="Logo" />
          </div>
          <div className="signup_signin_tab">
            <div className="signup_signin_tab_inner">
              <button
                className={activeTab === "signin" ? "active" : ""}
                onClick={() => handleTabClick("signin")}
              >
                <span>Sign In</span>
              </button>
              <button
                className={activeTab === "signup" ? "active" : ""}
                onClick={() => handleTabClick("signup")}
              >
                <span>Sign Up</span>
              </button>
            </div>
          </div>
          {activeTab === "signin" && (
            <SigninForm setActiveTab={handleTabClick} />
          )}
          {activeTab === "signup" && <SignupForm referalCode={referalCode} />}
          {activeTab === "forgot-password" && <ForgotPasswordForm />}
        </div>
      </div>
    </div>
  );
}

export default Signin;
